export default __webpack_public_path__ + "static/media/vodafone.d02aad25.jpg";